exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-command-editor-tsx": () => import("./../../../src/pages/command-editor.tsx" /* webpackChunkName: "component---src-pages-command-editor-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-info-command-editor-tsx": () => import("./../../../src/pages/info-command-editor.tsx" /* webpackChunkName: "component---src-pages-info-command-editor-tsx" */)
}

